import { marked } from 'marked';

export class MarkdownPreview {
  private container: HTMLElement;
  private isVisible: boolean = false;

  constructor(containerId: string) {
    const container = document.getElementById(containerId);
    if (!container) {
      throw new Error(`Container ${containerId} not found`);
    }
    this.container = container;

    // Configurar marked
    marked.setOptions({
      breaks: true,
      gfm: true
    });
  }

  update(content: string): void {
    if (!this.isVisible) return;

    try {
      const html = marked.parse(content) as string;
      this.container.innerHTML = html;
    } catch (e) {
      console.error('Error parsing markdown:', e);
      this.container.innerHTML = '<p style="color: var(--error)">Error al renderizar markdown</p>';
    }
  }

  show(): void {
    this.isVisible = true;
    this.container.classList.remove('hidden');
  }

  hide(): void {
    this.isVisible = false;
    this.container.classList.add('hidden');
    this.container.innerHTML = '';
  }

  toggle(): boolean {
    if (this.isVisible) {
      this.hide();
    } else {
      this.show();
    }
    return this.isVisible;
  }

  isShowing(): boolean {
    return this.isVisible;
  }

  // Scroll al porcentaje aproximado del documento basado en la línea
  scrollToLine(line: number, totalLines: number): void {
    if (!this.isVisible || totalLines <= 1) return;

    const scrollHeight = this.container.scrollHeight - this.container.clientHeight;
    if (scrollHeight <= 0) return;

    const percentage = (line - 1) / (totalLines - 1);
    const targetScroll = scrollHeight * percentage;

    this.container.scrollTo({
      top: targetScroll,
      behavior: 'smooth'
    });
  }
}
